import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'
import { AcknowledgeFileParams } from './shared/types'

export function useAcknowlegeFile() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: sendAcknowledgement,
    onSuccess: async (_, { fileId }) => {
      const fileDetailsKey = keys.file(fileId)
      await client.invalidateQueries({ queryKey: fileDetailsKey })
    },
  })

  async function sendAcknowledgement({ fileId }: AcknowledgeFileParams) {
    await server.post(
      `/v2/chat/repository/files/${fileId}/acknowledge`,
      {},
      'user'
    )
  }
}
